import { FC, useContext } from 'react';
import { ServerVarsContext } from '../../global/ServerVarsContext/ServerVarsContext';
import { createFragmentContainer, graphql } from 'react-relay/legacy';
import { getImageSrc } from 'dibs-buyer-layout/exports/imageHelpers';

import { ExpandableContent } from '../../components/global/ExpandableContent/ExpandableContent';
import { SbSharedStorefrontLink } from '../SbSharedStorefrontLink/SbSharedStorefrontLink';
import { SbRespContentModuleRegular_browseContentModule } from './__generated__/SbRespContentModuleRegular_browseContentModule.graphql';

import styles from './SbRespContentModuleRegular.scss';

const SB_TOP_NAV_VARIANT_MODULE_HEIGHT = 200;

type Props = {
    browseContentModule: SbRespContentModuleRegular_browseContentModule;
};

const SbRespContentModuleRegularComponent: FC<Props> = ({ browseContentModule }) => {
    const { description, title, photo } = browseContentModule;
    const { isSbTopNavVariant } = useContext(ServerVarsContext);
    const photoSrc = getImageSrc(photo, {
        width: 220,
        height: 220,
        fit: 'crop',
    });

    const MODULE_HEIGHT = title ? 130 : 120;

    return (
        <div className={styles.info}>
            {photo && (
                <img
                    className={styles.photo}
                    src={photoSrc || ''}
                    data-tn="facet-creator-picture"
                    alt={title || ''}
                />
            )}
            <ExpandableContent
                collapseHeight={
                    isSbTopNavVariant ? SB_TOP_NAV_VARIANT_MODULE_HEIGHT : MODULE_HEIGHT
                }
                dataTn="facet-creator-info"
                hideReadMoreArrow
                wrapperClassname={styles.expandableWrapper}
            >
                <div className={styles.content}>
                    {title && (
                        <div className={styles.title} data-tn="facet-creator-title">
                            {title}
                        </div>
                    )}
                    <span
                        className={styles.description}
                        dangerouslySetInnerHTML={{ __html: description || '' }}
                        data-tn="facet-creator-description"
                    />
                    <SbSharedStorefrontLink browseContentModule={browseContentModule} />
                </div>
            </ExpandableContent>
        </div>
    );
};

export const SbRespContentModuleRegular = createFragmentContainer(
    SbRespContentModuleRegularComponent,
    {
        browseContentModule: graphql`
            fragment SbRespContentModuleRegular_browseContentModule on ContentModuleRegular {
                ...SbSharedStorefrontLink_browseContentModule
                description
                title
                photo
            }
        `,
    }
);
